import arrowdown from "../assets/icons/arrow-down.png";
import styles from '../styles/home.module.scss';

interface OptionsHomeTasksProps {
  text: string;
  setTaksVilivility: (data: string) => void;
  taksassing: string;
  visibilityTasks: boolean;
}

export const OptionsHomeTasks = ({
  text,
  setTaksVilivility,
  taksassing,
  visibilityTasks
}: OptionsHomeTasksProps) => {
  return (
    <div className={styles["options_inicio_tasks"]}>
      <button className={styles["options_inicio_tasks__text"]} onClick={() => setTaksVilivility(taksassing)}>
        <img src={arrowdown} className={visibilityTasks
          ? `${styles["options_inicio_tasks__image-rotate"]}`
          : `${styles["options_inicio_tasks__image"]}`}
          width="18"
          height="10"
          alt="arrow-down"
        />
        <span className={styles["options_inicio_tasks__label"]}>
          {text}
        </span>
      </button>
    </div>
  );
};
